<template>
  <div style="position: relative;margin-bottom: 10px;">
    <div class="search-box">
      <div class="search-input">
        <van-search
          v-model="searchTxt"
          placeholder="搜索经销商或 PPN 账号"
          background="transparent"
          @search="handleSearch"
        />
      </div>
      <div class="btn-box"></div>
    </div>
    <div class="search-btn" @click="handleSearch">搜索</div>
  </div>
</template>

<script>
export default {
  name: 'search',
  props: {
    search: {
      type: String,
    },
  },
  data() {
    return {
      searchTxt: '',
    }
  },
  watch: {
    search(newVal, oldVal) {
      this.searchTxt = newVal
    },
  },
  methods: {
    handleSearch() {
      console.log(this.$route)
      if (this.$route.path == '/search') {
        //this.$route.query.txt = this.searchTxt
        this.$emit('handleSearch', this.searchTxt)
      } else {
        this.$router.push({
          path: '/search',
          query: {
            txt: this.searchTxt,
          },
        })
      }
    },
  },
  created() {},
  mounted() {
    this.searchTxt = this.search
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.search-box {
  display: flex;
  width: 100%;
  margin-bottom: 4px;
  height: 34px;
  .search-input {
    background: linear-gradient(180deg, #e6e6e6 0%, #fff 100%);
    width: 100%;
    height: 100%;
    border: 1px solid #403f45;
    border-right-color: transparent;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    .van-search {
      height: 100%;
      padding: 0;
      .van-cell {
        padding: 0;
        .van-icon-clear {
          right: 10px;
        }
      }
      .van-search__content {
        background: transparent;
        padding-left: 10px;
      }
    }
  }
  .btn-box {
    background: linear-gradient(180deg, #e6e6e6 0%, #fff 100%);
    position: relative;
    height: 34px;
    width: 60px;
    left: -4px;
    border: 1px solid #403f45;
    border-left-color: transparent;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    transform: skew(-10deg);
  }
}
.search-btn {
  position: absolute;
  top: 2px;
  right: 6px;
  width: 50px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  background-color: #403f45;
  color: #fff;
  font-size: 12px;
  font-weight: 300;
  border-radius: 4px;
  transform: skew(-10deg);
}
</style>
